import { Icon } from '../../atoms/Icon/Icon.styles'
import styled, { css } from 'styled-components'

export interface FooterProps {
  colorScheme: string;
}

export const FooterTop = styled.div`
  display: flex;
  flex-direction: column;
  
  ${({ theme }) => theme.mediaQuery.xxl(`
    flex-direction: row;
  `)}
`

export const Footer = styled.footer<FooterProps>`
  padding-top: ${({ theme }) => theme.rem(32)};
  padding-bottom: ${({ theme }) => theme.rem(32)};
  padding-left: ${({ theme }) => theme.rem(8)};
  padding-right: ${({ theme }) => theme.rem(8)};
  
  * {
    color: #FFF!important;
  }

  ${({ theme }) => theme.mediaQuery.lg(`
    padding-top: ${theme.rem(40)};
    padding-bottom: ${theme.rem(40)};
  `)}
  
  ${({ theme, colorScheme }) => css`
    background-color: ${theme.colorScheme[colorScheme].surface.inside};
    color: ${theme.colorScheme[colorScheme].surface.text.base.primary};
  `}

  ${FooterTop} {
    ${({ theme, colorScheme }) => theme.mediaQuery.xxl(`
    border-bottom: 1px solid ${theme.colorScheme[colorScheme].surface.line};
  `)}
    
  }
`

export const FooterInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.rem(40)};
  padding: 0;
`

export const FooterTrustpilotBadge = styled.div`
  margin-left: -22px;
`

export const FooterContactList = styled.div`
  display: flex;
  flex-direction: column;
`
export const FooterContactListItem = styled.div`
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.rem(8)};
  }

  ${Icon} {
    height: 100%;
    margin-right: ${({ theme }) => theme.rem(8)};
  }
`
export const FooterMenuListLabel = styled.div`
  margin-left: ${({ theme }) => theme.rem(8)};
`
export const FooterMenuListItem = styled.div`
  /* &:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.rem(8)};
  } */
`

export const FooterBottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: ${({ theme }) => theme.rem(40)};

  ${({ theme }) => theme.mediaQuery.lg(`
    flex-direction: column;
    align-items: flex-start;
  `, true)}
`

export const FooterBottomCopy = styled.div`
  ${({ theme }) => theme.mediaQuery.lg(`
    margin-bottom: ${theme.rem(24)};
  `, true)}
`

export const FooterBottomMenu = styled.div`

  ${({ theme }) => theme.mediaQuery.lg(`
    display: flex;
    gap: ${theme.rem(16)};
    flex-wrap: wrap;
    margin-bottom: ${theme.rem(24)};
  `, true)}

  ${({ theme }) => theme.mediaQuery.lg(`
    > * {
      &:not(:last-child) {
        margin-right: ${theme.rem(16)};
      }
    }
  `)}
`

export const FooterSocials = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.rem(8)};
  
  a {
    padding: ${({ theme }) => theme.rem(8, 0)};
    
    i {
      font-size: ${({ theme }) => theme.rem(24)}!important;
    }
  }


  ${({ theme }) => theme.mediaQuery.lg(`
    a {
      &:hover {
        path {
          fill: black!important;

          &:last-child:not(:first-child) {
            fill: white!important;
          }
        }
      }
    }
  `)};
`